import { useMobxStores } from '@stores/index';
import SearchStore from '@/stores/SearchStore';
import { observer } from 'mobx-react-lite';
import React, { useEffect, useState } from 'react';
import { IFacility } from '@/types';
import Head from 'next/head';

interface IPTitles {
  title: string;
}

interface IFacilityInfo {
  facility_branded: number;
  facility_lot?: string;
  facility_url_code: string;
  airport_initials: string;
  airport_name: string;
  facility_product_type: string;
  facility_description: string;
}

export function extractFacilityName(info: IFacilityInfo): string {
  const reg2 = new RegExp('\\d+', 'g');
  if (info.facility_branded == 1) {
    return info.facility_lot;
  } else {
    const arr = info.facility_url_code.match(reg2);
    let number = '';
    if (arr) {
      number = ' ' + arr[0];
    }
    if (info.facility_product_type) {
      return info.facility_product_type + ' ' + number;
    } else {
      return info.facility_lot;
    }
  }
}
export function extractFacilityFullName(info: IFacilityInfo): string {
  return (
    extractFacilityName(info) +
    ' - ' +
    info.airport_name +
    ' (' +
    info.airport_initials +
    ')'
  );
}
function TitleParkingAt({ info }: { info: IFacilityInfo }) {
  let pageTitle = extractFacilityFullName(info);
  if (!info.facility_branded && !info.facility_product_type) {
    pageTitle = `Cheapest Airport Parking at ${info.facility_lot} | On Air Parking
    Discount Rates `;
  }
  return (
    <>
      <Head>
        <title>{pageTitle}</title>
        <meta property="og:title" content={pageTitle} key="og:title" />

        <meta
          name="description"
          content={`${info.facility_description}.`}
          key="description"
        />
        <meta
          property="og:description"
          content={`${info.facility_description}.`}
          key="og:description"
        />
      </Head>
    </>
  );
}

export default observer(TitleParkingAt);
